const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <img 
              src="https://static.readdy.ai/image/f4befc687b50546f577c3e945d9e0997/76d35c9598ca23fc6f11923208cd1f7e.png" 
              alt="Global Grace Engineering" 
              className="h-24 w-auto object-contain mb-4 bg-white rounded-lg px-3 py-2"
            />
            <p className="text-gray-300 mb-4 max-w-md">
              Ingénierie • Innovation • Excellence
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-facebook-fill text-xl"></i>
                </div>
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-instagram-line text-xl"></i>
                </div>
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-linkedin-fill text-xl"></i>
                </div>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Construction neuve</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Rénovation</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Extension</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Aménagement</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <div className="space-y-2">
              <p className="text-gray-300 flex items-start">
                <div className="w-5 h-5 flex items-center justify-center mr-2 mt-1">
                  <i className="ri-map-pin-line"></i>
                </div>
                <span>31 Avenue des pins, Q/Bel air<br />C/Kampemba, Lubumbashi</span>
              </p>
              <p className="text-gray-300 flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-phone-line"></i>
                </div>
                +243 833111081
              </p>
              <p className="text-gray-300 flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-mail-line"></i>
                </div>
                <a 
                  href="mailto:contact@gge-cd.com" 
                  className="hover:text-white transition-colors cursor-pointer"
                >
                  contact@gge-cd.com
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2025 Global Grace Engineering. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
